// extracted by mini-css-extract-plugin
module.exports = {"color":"GplHFn","dropdown":"EHZqPm"};